import { render } from "./SkeletonTableOfContents.vue?vue&type=template&id=6267c27a"
import script from "./SkeletonTableOfContents.vue?vue&type=script&lang=js"
export * from "./SkeletonTableOfContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__